import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKey1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconKey1"><Path fillRule="evenodd" clipRule="evenodd" d="M1 12C1 8.68629 3.68629 6 7 6C9.0084 6 10.7857 6.98722 11.8739 8.5H20.8554L23.719 12L20.8554 15.5H17.7849L16 14.3844L14.2151 15.5H11.8739C10.7857 17.0128 9.0084 18 7 18C3.68629 18 1 15.3137 1 12ZM5.5 12C5.5 11.1716 6.17157 10.5 7 10.5C7.82843 10.5 8.5 11.1716 8.5 12C8.5 12.8284 7.82843 13.5 7 13.5C6.17157 13.5 5.5 12.8284 5.5 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconKey1;
